import { Link, useLocation, useNavigate } from 'react-router-dom';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/d9e2cd2a-e705-4286-aed3-7c72e1925a95/7a48abf8-a553-49ca-9e61-ca6f4e676f81_compressed_logo_main_rgb.webp';

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const goToAbout = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      document.getElementById('about')?.scrollIntoView({ behavior: 'auto' });
    } else {
      navigate('/#about');
    }
  };

  return (
    <footer className="bg-secondary-50 pt-20 pb-8 border-t border-secondary-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10 mb-16">
          <div className="md:col-span-2">
            <img src={LOGO_URL} alt="ROFF" className="h-12 w-auto object-contain mb-4" />
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs"
              style={{ fontFamily: "var(--font-body)" }}>
              かわいくて機能的なグッズで、<br />
              あなたの毎日をもっと楽しく、もっと素敵に。
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-900 mb-4 uppercase"
              style={{ fontFamily: "var(--font-heading)" }}>
              <a href="#shop">Shop</a>
            </h4>
            <div className="w-8 h-px bg-primary-300 mb-4"></div>
            <ul className="space-y-3">
              {[
                { label: 'すべての商品', href: '/products' },
                { label: 'グッズ', href: '/products' },
                { label: 'ミスト', href: '/products' },
              ].map(item => (
                <li key={item.label}>
                  <Link to={item.href} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-900 mb-4 uppercase"
              style={{ fontFamily: "var(--font-heading)" }}>
              <a href="/#about" onClick={goToAbout}>About</a>
            </h4>
            <div className="w-8 h-px bg-primary-300 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <a href="https://roff-official.pages.dev/" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  ROFFについて
                </a>
              </li>
              <li>
                <a href="/#about" onClick={goToAbout} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  コンセプト
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-900 mb-4 uppercase"
              style={{ fontFamily: "var(--font-heading)" }}>
              <a href="#support">Support</a>
            </h4>
            <div className="w-8 h-px bg-primary-300 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <Link to="/faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  よくある質問
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  配送について
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  返品・交換
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-200 pt-6 flex items-center justify-center">
          <p className="text-xs text-foreground-500">
            &copy; 2026 ROFF. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}